﻿"use strict";

window.getCookieValue = function getCookieValue(name, key) {
	return Cookies.get(`${name}.${key}`);
}

window.setCookieValue = function setCookieValue(name, key, value, expires) {
	Cookies.set(`${name}.${key}`, value, { expires: expires || new Date(9999, 12, 31) });
};